'use strict';

import { CoreRepository } from '../CoreRepository';
import { Agency } from '../../Entities/Agency/Agency';

export class AgencyRepository extends CoreRepository {
  public getAgency(userId: number, agencyId: number, options: object = {}, hydrate = false) {
    return this.webAPI.getAgency(userId, agencyId, options).then((response) => {
      if (hydrate) {
        const agency = new Agency();
        agency.hydrate(response);
        return agency;
      }
      return response;
    });
  }

  public getUserAgency(userId: number, options: object = {}) {
    return this.webAPI.getUserAgency(userId, options).then((response) => {
      const agency = new Agency();
      agency.hydrate(response);
      return agency;
    });
  }

  public updateAgency(userId: number, agencyId: number, payload: object = {}) {
    return this.webAPI.updateAgency(userId, agencyId, payload).then((response) => {
      return response;
    });
  }
}
